import { render, staticRenderFns } from "./result-card.component.vue?vue&type=template&id=3bd55a9e&scoped=true"
import script from "./result-card.component.vue?vue&type=script&lang=ts"
export * from "./result-card.component.vue?vue&type=script&lang=ts"
import style0 from "./result-card.component.vue?vue&type=style&index=0&id=3bd55a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd55a9e",
  null
  
)

export default component.exports